import { useState } from "react";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Dialog, IconButton, MenuItem, TextField } from "@mui/material";
import "./AssignChatbotDialog.css";
import "../../Components/Components.css";

const AssignChatbotDialog = ({ chatbotList, isOpen, setIsOpen }) => {
  const [selectedChannel, setSelectedChannel] = useState("");

  const channels = [
    {
      channelName: "instagram",
      icon: "skill-icons:instagram",
      assignedChatbotID: 1,
    },

    {
      channelName: "whatsapp",
      icon: "logos:whatsapp-icon",
      assignedChatbotID: 2,
    },

    {
      channelName: "facebook",
      icon: "logos:facebook",
      assignedChatbotID: 3,
    },
  ];

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog assign-chatbot-dialog"
      fullWidth
      maxWidth="md"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <div className="dialog-content">
          <h2 className="title">Assign Chatbot</h2>

          <div className="channel-list">
            {channels.map((channel, index) => (
              <div
                className={`channel ${channel.channelName} ${
                  selectedChannel === channel.channelName ? "selected" : ""
                }`}
                key={index}
                onClick={() => {
                  setSelectedChannel(channel.channelName);
                }}
              >
                <Icon height="34" icon={channel.icon} />

                <div className="name-selected">
                  <p className="channel-name">{channel.channelName}</p>
                </div>

                <TextField
                  className="search-item status-selector"
                  required
                  select
                  value={channel.assignedChatbotID}
                >
                  {chatbotList?.map((chatbot) => (
                    <MenuItem key={chatbot.ID} value={chatbot.ID}>
                      {chatbot.ScriptName}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            ))}
          </div>

          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>
        </div>

        <section className="buttons">
          <button className="cancel" type="button" onClick={handleClose}>
            Cancel
          </button>

          <button
            className="confirm"
            type="submit"
            onClick={() => {
              toast.success("Chatbots assigned");
              handleClose();
            }}
          >
            Apply
          </button>
        </section>
      </div>
    </Dialog>
  );
};

export default AssignChatbotDialog;
